import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Crew } from '../../shared/models/crew.interface';
import { CrewPersonnel } from '../../shared/models/crew.personnel.interface';
import { NgForm, UntypedFormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { User } from '../../shared/models/user.interface';
import { UserService } from '../../user/services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-crew',
  templateUrl: './crew.component.html',
  styleUrls: ['./crew.component.scss']
})
export class CrewComponent implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<CrewComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  crew: Crew;
  crewPersonnel = new UntypedFormControl();

  availablePersonnel: User[];
  errors: string;
  isRequesting: boolean;
  ngOnInit() {   
    let crewId: string = this.data.id;
    let dealerId = this.adminService.getDealerId();

    if (crewId == null) {
      this.crew = {} as Crew;
      this.crew.crew_IsActive = true;
    }
    else {
      this.adminService.getCrew(crewId)
        .subscribe({
          next: (data) => {
            data.selectedCrewLeader = data.crewLeader?.fieldTechnician_ID;
            data.crewPersonnel.forEach(function (value) {
              data.selectedCrewPersonnel.push(value.fieldTechnician_ID);
            });
            this.crew = data;
          }
        });
    }     
      //true indicates only active users should be returned
    this.adminService.getFieldTechs(dealerId)
      .subscribe({
        next: (data) => {
          this.availablePersonnel = data;
        }
      });
  }

  saveCrew(form: NgForm) {
    console.log('in crew onSubmit: ', this.crew);
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      if (this.crew.selectedCrewLeader === null ) {
        this.crew.crewLeader = null;
        this.crew.crew_Leader_ID = null;
      }

      let dealerId = this.adminService.getDealerId();
      this.crew.dealer_ID = dealerId;

      this.adminService.saveCrew(this.crew)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              this.dialogRef.close();
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
